import { Dialog, DialogContent, DialogProps, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { ReactNode, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';

export type GenericDialogProps = {
  content?: ReactNode;
  title?: ReactNode;
  subtitle?: ReactNode;
  open: boolean;
  onClose?: Function;
};

const BlurryDialog = styled(Dialog)<DialogProps>(({ theme }) => ({
  backdropFilter: 'blur(2px)',
}));

export const GenericDialog = (props: GenericDialogProps) => {
  const [open, setOpen] = useState(props.open);
  const { content, title, subtitle, onClose } = props;

  useEffect(() => {
    if (props.open != open) {
      setOpen(props.open);
    }
  }, [props.open]);

  const handleClose = () => {
    onClose && onClose();
    setOpen(false);
  };

  return (
    <BlurryDialog maxWidth="lg" onClose={handleClose} open={open} transitionDuration={0}>
      {title && (
        <DialogTitle sx={{ minWidth: { sm: '350px' }, m: 0, py: 1.5, pl: 3, pr: 7 }}>
          <Typography component="span" sx={{ display: 'block', color: '#007ca3', fontWeight: 600, fontSize: '1.15rem' }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography component="span" variant="body2" color="text.secondary" sx={{ display: 'block' }}>
              {subtitle}
            </Typography>
          )}
        </DialogTitle>
      )}
      <IconButton aria-label="Close" onClick={handleClose} sx={{ position: 'absolute', right: 8, top: 10, color: theme => theme.palette.grey[500] }}>
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>{content}</DialogContent>
    </BlurryDialog>
  );
};
